/* eslint-disable no-console */

function unregisterAllServiceWorkers () {
  if (!('serviceWorker' in navigator)) {
    return Promise.resolve()
  }

  return navigator.serviceWorker.getRegistrations()
    .then((registrations) => Promise.all(
      registrations.map((registration) => registration.unregister())
    ))
}

function clearBrowserCaches () {
  if (!('caches' in window)) {
    return Promise.resolve()
  }

  return caches.keys()
    .then((cacheNames) => Promise.all(
      cacheNames.map((cacheName) => caches.delete(cacheName))
    ))
}

if (process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    unregisterAllServiceWorkers()
      .then(() => clearBrowserCaches())
      .catch((error) => {
        console.error('Service worker cleanup failed:', error)
      })
  })
}
